var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.329,
    height: 14.626,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-370 15295)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(370 -15295)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(375 -15285)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.329,5.3a7,7,0,0,0-2.948-3.491A12.725,12.725,0,0,0,18.347.434,18.559,18.559,0,0,0,10.417.427,13.678,13.678,0,0,0,.03,14.626a2.462,2.462,0,0,0,.66-1.068,11.927,11.927,0,0,1,5.454-5.9.828.828,0,0,1,.5-.131c.344.056.474.469.568.8a5.531,5.531,0,0,0,5.278,3.912A5.531,5.531,0,0,0,17.6,8.116a1.134,1.134,0,0,1-1.611.009,1.092,1.092,0,0,1,.2-1.582,1.054,1.054,0,0,1,1.5.494q-.007-.951-.016-1.9a25.79,25.79,0,0,1,3.516.031.563.563,0,0,1,.313.089c.167.134.129.394.068.6a10.615,10.615,0,0,1-5.316,6.009A26.978,26.978,0,0,1,8.421,14.3a23.127,23.127,0,0,0,9.948-1.306A11.96,11.96,0,0,0,24.65,7.4a8.536,8.536,0,0,0,.578-1.513",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eyeOFF.e61ab8510b40f2e7069521b9bf71ee54.svg";
export { ForwardRef as ReactComponent };